import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class PayrollTypeFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async onChange(value, field) {
    const seen = new Set();
    const filteredValue = [];

    for (const item of value) {
      if (!seen.has(item?.classification?.earnings)) {
        seen.add(item?.classification?.earnings);
        filteredValue.push(item);
      }
    }

    if (filteredValue.length < value.length) {
      this.showError(
        "Duplicate earnings are not allowed. Only the first entry was kept."
      );
    }

    this.change[field] = filteredValue;
    this.object[field] = filteredValue;
    this.view.setObject(this.object);
  }

  async save() {
    const collection = this.view.getCollectionName();
    const change = this.change;

    const payrollClassification = (change.payrollRelation || [])
      .filter((item) => item.classification?.id)
      .map((item) => ({ id: item.classification.id }));

    try {
      if (this.view.props.selected.length > 0) {
        const updatePromises = this.view.props.selected.map(({ id }) => {
          const updateData = {
            id,
            payrollRelation: this.change.payrollRelation,
            payrollClassification: payrollClassification,
          };

          return this.upsertUseCase.execute(collection, updateData);
        });

        await Promise.all(updatePromises);
      } else if (this.view.props.mode === "edit") {
        const updateData = {
          id: this.view.props.employeeData?.id,
          payrollRelation: this.change.payrollRelation,
          payrollClassification: payrollClassification,
        };

        await this.upsertUseCase.execute(collection, updateData);
      } else { 
        console.log("No employees found.");
      }
      this.view.props.refetchData();
      this.view.props.closeModal();
      this.view.props.savedData();
    } catch (error) {
      throw error;
    }
  }
}

export default PayrollTypeFormPresenter;
